<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (editForm) {
    @if (logicalConfig.crs.properties.layersModeEnabled) {
        <div class="form-group row justify-content-start mt-3">
            <span class="form-label col-3 mt-auto">{{ 'project.layerName' | translate }}</span>
            <div class="col-9">
                <winde-reactive-input [form]="editForm" [input]="layerNameInput"></winde-reactive-input>
            </div>
        </div>
    }
    <div class="form-group row">
        <div class="col-6">
            <span class="form-label">Location required rate (Mbit/sec)</span>
            <winde-reactive-input [form]="editForm" [input]="requiredRateInput"></winde-reactive-input>
        </div>
        <div class="col-6">
            <span class="form-label"> Default height above ground</span>
            <winde-reactive-input [form]="editForm" [input]="defaultHeightInput"></winde-reactive-input>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-6" style="align-self: end">
            <span class="form-label">Pole block angle</span>
            <winde-reactive-input [form]="editForm" [input]="blockedByPoleAngle"></winde-reactive-input>
        </div>
        <div class="col-6 blockedByPoleControl">
            <span class="form-label">Blocked by pole</span>
            <sui-toggle-component [config]="isBlockedByPoleToggle"></sui-toggle-component>
        </div>
    </div>
}
